<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h2 id="mainTitle">供給先関連情報</h2>

<!-- 基本情報コンポーネント -->

<app-sgke390d-info *ngIf="initResponse" [initResponse]="initResponse" [visitormei]="dialogData.visitormei"
  [codeMap]="codeMap">
</app-sgke390d-info>
<div *ngIf="!initResponse">
  <div
    class="btn_area_right tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
    <mat-dialog-actions>
      <button type="button" mat-dialog-close mat-raised-button color="primary" class="btn">閉じる</button>
    </mat-dialog-actions>
  </div>
</div>